/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  dummy: 'dummy_ad3aef5c',
};

export = styles;

loadStyles([{"rawString":".dummy_ad3aef5c{background:#00f}"}]);
/* tslint:enable */